
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { toast } from 'react-toastify';
import Avatar from './common/Avatar';
import { BASEURL } from '../constants';

const ChangePassword = () => {
    const [data, setData] = useState({});
    const [passwordVisible, setPasswordVisible] =useState(false);
    const [pass1,setPass1]=useState('')
    const [pass2,setPass2]=useState('')
    const [pass3,setPass3]=useState('')
    const [pass_check,setPass_check]=useState(false)
    const[isSubmit,setSubmit]=useState(false)
    const[pass_show,setpass]=useState(false)
    const[pass_show2,setpass2]=useState(false)
    const [passwordError,setPasswordError]=useState(false)

    const navigate=useNavigate()
    useEffect(() => {
        if(pass2 !== pass3){
            setPass_check(true)
        } else {
            setPass_check(false)
        }
    }, [pass2, pass3])

    const studentName = localStorage.getItem("studentName");
    const handlecheck= async () => {
     if(passwordError===false)
    {
    
                    if(pass2 === pass3)
                    {   
                        setSubmit(true)
                        try {
                            let studentid = localStorage.getItem("studentId");
                            const temp =  await axios.get(BASEURL + `Student/UpdatePassword/${studentid}?currentpass=${pass1}&newpass=${pass2}`)
                            toast.success(temp.data.message)
                            navigate("/dashboard")
                        } catch (error) {
                        toast.error(error.response.data.message)
                        
                        }
                        finally{
                            setPass1('')
                            setPass2('')
                            setPass3('')
                            setSubmit(false)
                        }
                    }
                        else{
                            toast.error('Password do not match');
                    
                        }
                        
    }
    else{
        toast.error('Invalid Password Format')
    }

      
    }
    const togglepassw=()=>{
        setpass(prevState=>!prevState)
    }
    const togglepassw2=()=>{
        setpass2(prevState=>!prevState)
    }

    const validatePasswords = () => {
        const isValid = pass2.length >= 8 && /[A-Z]/.test(pass2) && /[a-z]/.test(pass2) && /\d/.test(pass2);
        setPasswordError(!isValid);
        return isValid;
    };
    const handlePasswordChange = (e) => {
        setPass2(e.target.value);
        validatePasswords();
    };
 
  return (
   <>
      
        <div className="min-h-[calc(100vh-150px)] bg-slate-50 flex items-center justify-center px-4 py-10">
            <div className="flex flex-col items-center w-full">
                {/* <div className="flex justify-center mb-4">
                <Avatar
                    className="rounded-full w-[100px] h-[100px]"
                    url={`https://ui-avatars.com/api/name=${studentName}/?background=random`}
                />
                </div> */}

                <div className="w-full max-w-[520px] bg-white border border-slate-200 shadow-sm p-6 rounded-2xl">
                    <h2 className="text-lg text-center font-medium text-slate-900 mb-6">Change Password</h2>

                    <div className="flex flex-col gap-4">
                        {/* Old password */}
                        <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">
                            Old password
                        </label>
                        <div className="flex relative">
                            <input
                            className="w-full font-normal px-3 py-2 rounded-lg focus:outline-none text-slate-900 placeholder-slate-400 border border-slate-300 focus:border-blue-600 focus:ring-2 focus:ring-blue-200"
                            placeholder="Enter old password"
                            type={pass_show ? "text" : "password"}
                            value={pass1}
                            onChange={(e) => setPass1(e.target.value)}
                            size="large"
                            />
                            <button
                            type="button"
                            className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-slate-500 hover:text-slate-700"
                            onClick={togglepassw}
                            >
                            {pass_show ? <FaEye /> : <FaEyeSlash />}
                            </button>
                        </div>
                        </div>

                        {/* New password */}
                        <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">
                            New password
                        </label>
                        <div className="flex relative">
                            <input
                            className={`w-full font-normal px-3 py-2 rounded-lg focus:outline-none text-slate-900 placeholder-slate-400 border ${
                                pass_check ? "border-red-400" : "border-slate-300"
                            } focus:border-blue-600 focus:ring-2 focus:ring-blue-200`}
                            status={pass_check ? "error" : ""}
                            placeholder="Enter new password"
                            value={pass2}
                            onChange={handlePasswordChange}
                            type={pass_show2 ? "text" : "password"}
                            size="large"
                            />
                            <button
                            type="button"
                            className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-slate-500 hover:text-slate-700"
                            onClick={togglepassw2}
                            >
                            {pass_show2 ? <FaEye /> : <FaEyeSlash />}
                            </button>
                        </div>

                        <div className="mt-1">
                            <span className="text-xs text-red-500">
                            {passwordError &&
                                "Password must include a number, uppercase letter, lowercase letter, and special character"}
                            </span>
                        </div>
                        </div>

                        {/* Confirm password */}
                        <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">
                            Confirm password
                        </label>
                        <div className="flex relative">
                            <input
                            className={`w-full font-normal px-3 py-2 rounded-lg focus:outline-none text-slate-900 placeholder-slate-400 border ${
                                pass_check ? "border-red-400" : "border-slate-300"
                            } focus:border-blue-600 focus:ring-2 focus:ring-blue-200`}
                            status={pass_check ? "error" : ""}
                            placeholder="Re-enter new password"
                            value={pass3}
                            onChange={(e) => setPass3(e.target.value)}
                            size="large"
                            type={pass_show2 ? "text" : "password"}
                            />
                            <button
                            type="button"
                            className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-slate-500 hover:text-slate-700"
                            onClick={togglepassw2}
                            >
                            {pass_show2 ? <FaEye /> : <FaEyeSlash />}
                            </button>
                        </div>
                        </div>

                        <button
                        type="button"
                        onClick={handlecheck}
                        disabled={isSubmit}
                        className="mt-2 w-full font-semibold px-3 py-2.5 rounded-lg text-white bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed"
                        >
                        Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>

   
    </>
  )
}

export default ChangePassword
